// multi-select.component.ts
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-checkbox",
  templateUrl: "./checkbox.component.html",
  styleUrls: ["./checkbox.component.scss"],
})
export class CheckboxComponent implements OnInit {
  // Outputs to emit the changes to the parent
  // @Output() countChange = new EventEmitter<number>();
  // @Output() checkboxChange = new EventEmitter<boolean>();

  @Input() label: string = "";
  @Input() inChecked?: boolean;
  // @Input() inCount?: number;
  @Input() key: string = "";
  @Input() parentStateHandler?: (key: string, { count, check }: { count?: number; check?: boolean }) => void;
  @Input() withCount?: boolean = false;

  constructor() {}

  // public countState: number = 1; // Checkbox counter state
  public isCheckedState: boolean = false; // Checkbox checked state

  ngOnInit(): void {
    // this.countState = this.inCount ?? 1;
    this.isCheckedState = this.inChecked ?? false;
  }

  public increment() {
    // this.countState = this.countState + 1;
    // this.countChange.emit(this.count); // Emit updated count to the parent
    this.parentStateHandler(this.key, {
      // count: this.countState,
      check: this.isCheckedState,
    });
  }

  public decrement() {
    // if (this.countState == 1) return;
    // this.countState = this.countState - 1;
    // this.countChange.emit(this.count); // Emit updated count to the parent
    this.parentStateHandler(this.key, {
      // count: this.countState,
      check: this.isCheckedState,
    });
  }

  public onCheckboxChange(event: any) {
    this.isCheckedState = event.target.checked;
    // this.checkboxChange.emit(this.isChecked); // Emit checkbox status to the parent
    this.parentStateHandler(this.key, {
      // count: this.countState,
      check: this.isCheckedState,
    });
  }
}
